import { head } from "lodash";
import API_MAPS from "../modules/API/api_maps";
import SETCOORDS from "../modules/API/set_coords";
SETCOORDS();
/*

    Summary
        0 - Functions
        1 - Initial Config
        2 - Init Map


*/

/*---------------------- 0 - Functions -------------------*/
function getAddressesStores() {
    let addressesObj = $.ajax({
        type: "POST",
        url: $("#page-maps-stores").attr('adressesRoute'),
        data: "",
        dataType: "json",
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    }).done(() => {
        const allAddress = addressesObj.responseJSON;
        API_MAPS(allAddress);
    });
}

/*---------------------- 1 - Initial Config -------------------*/
const socialIcons = document.getElementById('component--social-icons')
socialIcons.style.display = 'none'

const header = document.querySelector('header')
header.classList.add("maps-page")

const footer = document.querySelector('footer')
footer.classList.add("maps-page")


document.documentElement.style.setProperty('--zoom', 1);



/*----------------------  2 - Init Map -------------------*/
window.onload = ()=>{
    getAddressesStores()
}